module.exports = __webpack_public_path__ + "media/images/sp/stores/sapporo/sapporo_concept_01-6bacfe0331b384e6f168666e41afae07.jpg";